import { Button } from "devextreme-react";
import React from "react";
import { useDispatch } from "react-redux";
import { updateSelectedDoc } from "../common/Redux/AuditDocumentViewer";

export default function FileItem(props) {
  const { docNo, docTitle } = props;

  const dispatch = useDispatch();

  const onClickPdf = () => {
    dispatch(
      updateSelectedDoc({
        docNo: docNo,
        docTitle: docTitle,
        action: "view",
      })
    );
  };

  return (
    <React.Fragment>
      <Button
        icon="pdffile"
        style={{
          marginTop: "0px",
          marginBottom: "0px",
          paddingTop: "0px",
          paddingBottom: "0px",
          marginRight: "0px",
        }}
        onClick={onClickPdf}
      />
    </React.Fragment>
  );
}
